import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};

VCA.DbCardsCarousel = (function ($) {

    function bindEvents() {
        $(window).on('resize', onWindowResize);
    }

    function onWindowResize() {
        let viewportWidth = $(window).width();
        if (viewportWidth > 767) {
            initCarousel();
        }
    }

    function initCarousel() {
        if (isExperienceEditor) {
            return; 
        }

        let viewportWidth = $(window).width();
        if (viewportWidth < 767) {
            return;
        }

        const $carousel = $('.js-cards-carousel');
        const showCount = Number($carousel.data('show-count'));
        const slidesToShow = !isNaN(showCount) ? showCount : 3;

        if($carousel.hasClass("coveo-card-layout-container")){
            $carousel.children('.coveo-card-layout-padding').remove();
        }


        $carousel.not('.slick-initialized').slick({
            lazyLoad: "ondemand",
            dots: false,
            slidesToShow,
            infinite: false,
            draggable: false,
            accessibility: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: "unslick" //Note: Clears out all event handlers
                }
            ]
        });
    }

    function init() {
        bindEvents();
        initCarousel();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.DbCardsCarousel.init();
});